import React from 'react';
import './LogoCarousel.css';

// --- 1. IMPORTA CADA LOGO COMO UNA VARIABLE ---
// Esta es la forma correcta de usar imágenes desde la carpeta 'src'
import logoAni from '../../uploads/logotipo/ani.png';
import logoInvias from '../../uploads/logotipo/invas_colombia_logo-afa4g.png';
import logoRepublica from '../../uploads/logotipo/diario-la-republica.png';
import logoSuperTransporte from '../../uploads/logotipo/supertransporte-web.png';
import logoMinTransporte from '../../uploads/logotipo/mintrasporte-2023.png';
import logoSISGA from '../../uploads/logotipo/SISGA.png';
import logosisga from '../../uploads/logotipo/logo-sisga.png';
import ryq from '../../uploads/logotipo/RyQ.png';


// --- 2. USA LAS VARIABLES IMPORTADAS EN EL ARRAY ---
const logos = [
  {
    id: 1,
    name: 'ANI',
    logoUrl: logoAni, // <-- Usa la variable importada
    linkUrl: 'https://www.ani.gov.co/',
  },
  {
    id: 2,
    name: 'INVIAS',
    logoUrl: logoInvias, // <-- Usa la variable importada
    linkUrl: 'https://www.invias.gov.co/',
  },
  {
    id: 3,
    name: 'Diario La República',
    logoUrl: logoRepublica, // <-- Usa la variable importada
    linkUrl: 'https://www.larepublica.co/',
  },
  {
    id: 4,
    name: 'Super Transporte',
    logoUrl: logoSuperTransporte, // <-- Usa la variable importada
    linkUrl: 'https://www.supertransporte.gov.co/',
  },
  {
    id: 5,
    name: 'MinTransporte',
    logoUrl: logoMinTransporte, // <-- Usa la variable importada
    linkUrl: 'https://www.mintransporte.gov.co/',
  },
  {
    id: 6,
    name: 'SISGA',
    logoUrl: logoSISGA, // <-- Usa la variable importada
    linkUrl: 'https://community.secop.gov.co/Public/Tendering/OpportunityDetail/Index?noticeUID=CO1.NTC.7915096&isFromPublicArea=True&isModal=False',
  },
  {
    id: 7,
    name: 'SISGA-TRANS',
    logoUrl: logosisga, // <-- Usa la variable importada
    linkUrl: 'https://www.concesiondelsisga.com.co/',
  },

    {
    id: 8,
    name: 'RYQ',
    logoUrl: ryq, // <-- Usa la variable importada
    linkUrl: 'https://www.ryq.cl/',
  },

];

const LogoCarousel = () => {
  // El resto del componente no necesita cambios
  const extendedLogos = [...logos, ...logos];

  return (
    <div className="logo-carousel-section">
      <div className="logo-carousel-track">
        {extendedLogos.map((logo, index) => (
          <a
            key={index}
            href={logo.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="logo-slide"
            aria-label={`Logo de ${logo.name}`}
          >
            <img src={logo.logoUrl} alt={`Logo de ${logo.name}`} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;
